import React from "react";
import Skeleton from "react-loading-skeleton";

// Placeholder shown while the fiduciary (and its uaSettings / allowedTabs) is
// still loading after a community switch. Mimics the settings layout: the tab
// bar, the portal sub-tabs, the portal header card, and the "activate/reorder
// apps" list (drag handle · icon · name · action link · toggle).

const AppRowSkeleton = ({ withLink }) => (
  <div
    style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      border: "1px solid #eef0f4",
      borderRadius: "8px",
      padding: "0.75rem 1rem",
      marginBottom: "0.75rem",
    }}
  >
    {/* left: drag handle + icon + name */}
    <div style={{ display: "flex", alignItems: "center", gap: "0.75rem" }}>
      <Skeleton width={6} height={26} borderRadius={3} />
      <Skeleton circle width={40} height={40} />
      <Skeleton width={120} height={16} />
    </div>
    {/* right: optional action link + toggle */}
    <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
      {withLink && <Skeleton width={150} height={12} />}
      <Skeleton width={44} height={22} borderRadius={11} />
    </div>
  </div>
);

const SettingsSkeleton = () => {
  return (
    <div>
      {/* Main tab bar */}
      <div
        style={{
          display: "flex",
          gap: "1rem",
          padding: "0.5rem",
          border: "1px solid #eef0f4",
          borderRadius: "12px",
        }}
      >
        {Array.from({ length: 5 }).map((el, i) => (
          <div key={`tab-skeleton-${i}`} style={{ flex: 1 }}>
            <Skeleton height={40} borderRadius={8} />
          </div>
        ))}
      </div>

      {/* Section subtitle */}
      <div style={{ margin: "1.5rem 0 1rem" }}>
        <Skeleton height={16} width="60%" />
      </div>

      {/* Sub-tabs (Collaborateur / Client / Public) */}
      <div style={{ display: "flex", gap: "2rem", marginBottom: "1.5rem" }}>
        {Array.from({ length: 3 }).map((el, i) => (
          <Skeleton key={`subtab-skeleton-${i}`} height={14} width={110} />
        ))}
      </div>

      {/* Portal header card */}
      <div
        style={{
          border: "1px solid #eef0f4",
          borderRadius: "12px",
          padding: "1.5rem",
          marginBottom: "1.5rem",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "1rem",
          }}
        >
          <Skeleton height={22} width={200} />
          <Skeleton width={48} height={24} borderRadius={12} />
        </div>
        <Skeleton height={13} count={2} style={{ marginBottom: "0.35rem" }} />
      </div>

      {/* "Activer/désactiver ou Modifier l'ordre des applications" label */}
      <div style={{ marginBottom: "1rem" }}>
        <Skeleton height={14} width={280} />
      </div>

      {/* App list */}
      <AppRowSkeleton withLink />
      <AppRowSkeleton withLink />
      <AppRowSkeleton />
      <AppRowSkeleton />
    </div>
  );
};

export default SettingsSkeleton;
